
import React from 'react';

interface BreathingStatusProps {
  breathingPhase: 'inhale' | 'hold' | 'exhale';
  secondsLeft: number;
  isMobile: boolean;
}

const BreathingStatus: React.FC<BreathingStatusProps> = ({ 
  breathingPhase, 
  secondsLeft,
  isMobile 
}) => {
  return (
    <div 
      className={`text-center mt-3 sm:mt-6 ${isMobile ? 'text-xl' : 'text-2xl'} font-bold`}
      aria-live="assertive"
      aria-atomic="true"
    >
      {`${breathingPhase.toUpperCase()} - ${secondsLeft}`}
    </div>
  );
};

export default React.memo(BreathingStatus);
